type DropDownFilter2Options = {
  rootSelector?: string;
  btnSelector?: string;
  boxSelector?: string;
  inputSelector?: string;
  textSelector?: string;
  counterSelector?: string;
  activeClass?: string;
  selectedClass?: string;
};

export function initDropDownFilter2({
  rootSelector = '.drop-down-filter-2',
  btnSelector = '.drop-down-filter-2__btn',
  boxSelector = '.drop-down-filter-2__box',
  inputSelector = '.drop-down-filter-2__input',
  textSelector = '.text',
  counterSelector = 'i',
  activeClass = 'active',
  selectedClass = 'selected'
}: DropDownFilter2Options = {}): void {
  const dropdowns = document.querySelectorAll<HTMLElement>(rootSelector);
  if (!dropdowns.length) return;

  const closeAll = (): void => {
    dropdowns.forEach(dd => {
      dd.querySelector<HTMLElement>(btnSelector)?.classList.remove(activeClass);
      dd.querySelector<HTMLElement>(boxSelector)?.classList.remove(activeClass);
    });
  };

  dropdowns.forEach(dropdown => {
    const button = dropdown.querySelector<HTMLElement>(btnSelector);
    const box = dropdown.querySelector<HTMLElement>(boxSelector);
    const inputs = box?.querySelectorAll<HTMLInputElement>(inputSelector);
    const closeBtn = box?.querySelector<HTMLElement>('.js-close');
    const text = button?.querySelector<HTMLElement>(textSelector);
    const counter = text?.querySelector<HTMLElement>(counterSelector);

    if (!button || !box || !inputs?.length || !text || !counter) return;

    const updateState = (): void => {
      const checked = box.querySelectorAll<HTMLInputElement>(
        `${inputSelector}:checked`
      ).length;

      counter.textContent = String(checked);
      button.classList.toggle(selectedClass, checked > 0);
    };

    const open = (): void => {
      closeAll();
      button.classList.add(activeClass);
      box.classList.add(activeClass);
      document.addEventListener('click', onOutsideClick);
      document.addEventListener('keydown', onEsc);
    };

    const close = (): void => {
      button.classList.remove(activeClass);
      box.classList.remove(activeClass);
      document.removeEventListener('click', onOutsideClick);
      document.removeEventListener('keydown', onEsc);
    };

    const onOutsideClick = (e: MouseEvent): void => {
      if (!dropdown.contains(e.target as Node)) {
        close();
      }
    };

    const onEsc = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') {
        close();
      }
    };

    button.addEventListener('click', (e: MouseEvent) => {
      e.preventDefault();
      button.classList.contains(activeClass) ? close() : open();
    });

    inputs.forEach(input => {
      input.addEventListener('change', () => {
        updateState();

        // если radio — закрываем сразу
        if (input.type === 'radio') {
          close();
        }
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', (e: MouseEvent) => {
        e.preventDefault();
        close();
      });
    }

    updateState();
  });
}